import LoginForm from './login-form.container';

export default LoginForm;



// WEBPACK FOOTER //
// ./src/login-form/index.js